import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon, Typography } from '@mui/material';

import { MplButton } from '../../atoms/MplButton/MplButton';
import MailFilledIcon from '../../icons/MailFilledIcon.svg';
import { CompleteAnim } from '../../molecules/Animations';
import { MplModal } from '../MplModal/MplModal';

interface IProps {
	open: boolean;
	onClose: VoidFunction;
	email?: string | null;
}

export const EmailResentSuccessModal: FC<IProps> = ({
	open,
	onClose,
	email = '',
}) => {
	const { t } = useTranslation('registration');

	return (
		<MplModal
			open={open}
			testId="EmailResentSuccessModal-MplModal"
			icon={<CompleteAnim />}
			onBackDropClick={onClose}
			title={t('resendSuccess.title')}
			content={
				<Typography variant="body1">
					{t('resendSuccess.body', { email })}
				</Typography>
			}
			buttons={
				<MplButton
					color="primaryButtonV2"
					data-testid="EmailResentSuccessModal-primary-button"
					startIcon={<SvgIcon component={MailFilledIcon} inheritViewBox />}
					onClick={onClose}
					type="button"
					fullWidth
				>
					{t('resendSuccess.primaryButton')}
				</MplButton>
			}
			textAlign="center"
		/>
	);
};
